<template lang="pug">
  b-container.page-container
    header-without-menu
    div.content
      b-row.header
        img(src="../../../assets/logo_big.png")
      b-row.title
        div 파트너 원격
      div.form-container
        b-form(@submit="onSubmit").form-style
          div
            b-form-group
              b-form-input(type="text", v-model="form.email", placeholder="이메일")
              b-form-input(type="text", v-model="form.passwd", placeholder="비밀번호")
          b-container.setting-container
            //b-row.setting-row.mb-3(v-if="remember !== null")
            b-row.setting-row.mb-3
              toggle-box(:checked="remember", @input="changeRememberId")
                span.remember-label(v-if="AppState.isApplication") 자동 로그인
                span.remember-label(v-else) {{$t('ID')}} {{$t('save')}}
              b-form-radio-group(v-model="modeSelected", :checked="saveViewMode", @input="handleModeChange")
                b-form-radio.remember-label(value="simple") {{$t('mode_simple')}}
                b-form-radio.remember-label(value="normal") {{$t('mode_normal')}}
            template(v-if="!AppState.isStandalone")
              b-row
                b-link(variant="link", size="sm", :to="{name: 'forgot', params: {type: 'temporary'}}") {{$t('find_n', {v: $t('PW')})}}
          b-container
            b-row
              b-button.w-100(variant="primary", size="lg", type="submit") {{$t('login')}}
            b-row.mt-2
              //b-button.w-100.free-trial-btn(size="lg", type="button", :to="{name: 'join-us'}") 파트너 계정 신청
              b-button.w-100.free-trial-btn(size="lg", type="button", @click="navigateToPartnerJoin") 파트너 계정 신청
          // 공지사항 관련 부분
          // b-row
          //  b-list-group(style="width:100%; margin-top:14px;")
          //    b-list-group-item(
          //      href="javascript:void(0)",
          //      v-for="item in notice",
          //      :key="item.pk",
          //      @click="noticePopupOpen(item)")
          //      div.notice-body {{item.notice_title}}
          //      b-badge(variant="light").notice-badge {{item.notice_date | moment('YYYY-MM-DD')}}

</template>

<script>
import {HeaderWithoutMenu} from '../../mixins/header'
import ToggleBox from "../../mixins/togglebox/togglebox.vue";
import { store } from "@/api/store";

export default {
  name: 'partner-login',
  components: {ToggleBox, HeaderWithoutMenu},
  methods: {
    onSubmit() {
      return console.log('로그인을 눌렀어요')
    },
    changeRememberId(value) {
      this.remember = value
      console.log(this.remember)
      if (this.AppState.isApplication) {
        this.autoLoginStateHandler(value)
      }
    },
    handleModeChange(value) {
      this.saveViewMode = value
    },
    navigateToPartnerJoin() {
      this.$router.push('partner-join')
    },
    noticePopupOpen (notice) {
      this.noticePopup.content = notice
      this.noticePopup.skipCheck = false
      this.noticePopup.show = true
    },
    noticePopupClose () {
      this.noticePopup.show = false
      if (this.noticePopup.skip) {
        store.set('notice_skip', this.noticePopup.content.pk)
      }
    },
  },
  data() {
    return {
      form: {
        email: '',
        passwd: ''
      },
      remember: null,
      saveViewMode: null,
      modeSelected: 'normal',
      notice: [],
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  padding-top: 7rem;
}

.header {
  justify-content: center;
  margin-bottom: 1rem;

  > img {
    width: 17rem;
  }
}

.title {
  justify-content: center;
  margin: 1rem 0 0 0;

  > div {
    font-size: 2rem;
    font-weight: 550;
    letter-spacing: 1px;
  }
}

.form-container {
  display: flex;
  justify-content: center;

  > .form-style {
    margin-top: 1.5rem;
    width: 40%;

    .form-group {
      width: 100%;

      input {
        margin-bottom: 0.1rem;
      }
    }
  }
}

.setting-container {
  display: flex;
  justify-content: space-between;
  margin-left: 5px;


  .setting-row {
    label {
      margin-right: 20px;
    }
  }
}

</style>
